import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Type,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { ControlBase } from '../base/base.component';
import { DatePickerType } from '../../models/date.model';
import { ALLOWED_INPUTS_BY_DATE_TYPE, DATE_PICKER_TYPES } from './constants/date.constants';
import { NgComponentOutlet } from '@angular/common';

@Component({
  selector: 'control-date',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NzDatePickerModule, ReactiveFormsModule, NgComponentOutlet],
  template: `
    @if (componentControl()) {
      <ng-container
        *ngComponentOutlet="componentControl(); inputs: combinedInputs()"
      />
    }
  `,
})
export class ControlDateComponent extends ControlBase {
  private readonly DATE_PICKER_TYPES: Record<DatePickerType, Type<unknown>> =
    DATE_PICKER_TYPES;
  private readonly DEFAULT_PICKER_TYPE: DatePickerType = 'date';

  subType = input<DatePickerType>(this.DEFAULT_PICKER_TYPE);
  typeInputs = input<{ [key: string]: any }>({});

  componentControl = computed(() => this.getControl(this.subType()));

  baseInputs = computed(() => ({
    label: this.label(),
    control: this.control(),
    subType: this.subType(),
  }));

  combinedInputs = computed(() => ({
    ...this.baseInputs(),
    ...this.filterTypeInputs(this.subType(), this.typeInputs()),
  }));

  private getControl(type: DatePickerType): Type<unknown> | null {
    return this.DATE_PICKER_TYPES[type] || null;
  }

  private filterTypeInputs(
    type: DatePickerType,
    inputs: { [key: string]: any },
  ): { [key: string]: any } {
    const allowedInputs = ALLOWED_INPUTS_BY_DATE_TYPE[type] || [];
    return Object.keys(inputs)
      .filter((key) => allowedInputs.includes(key))
      .reduce(
        (acc, key) => {
          acc[key] = inputs[key];
          return acc;
        },
        {} as { [key: string]: any },
      );
  }
}
